<template>
  <div>
    <Header>
      Użytkownicy
      <template #right>
        <b-button variant="primary" size="sm" @click="$inertia.visit(route('users.create'))">
          <b-icon icon="plus" />
        </b-button>
      </template>
    </Header>

    <b-table-simple :responsive="true" striped :small="isMobile" class="table-vcenter">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>Lp.</b-th>
          <b-th>Użytkownik</b-th>
          <b-th>Login</b-th>
          <b-th>Rola</b-th>
          <b-th>#</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(user, idx) in users" :key="user.id">
          <b-td>
            <span v-if="user.deleted_at">
              <b-icon icon="x-circle" class="text-danger" />
            </span>
            <span v-else>
              {{ idx+1 }}
            </span>
          </b-td>
          <b-td>
            <span v-if="!user.deleted_at">
              {{ user.name }}
            </span>
            <span v-else>
              <del>{{ user.name }}</del>
            </span>
          </b-td>
          <b-td>
            <span>
              {{ user.login }}
            </span>
          </b-td>
          <b-td>
            <span
              :class="{
                'bg-secondary': user.is_user,
                'bg-success': user.is_moderator,
                'bg-danger': user.is_admin,
              }"
              class="text-white rounded px-1"
            >
              {{ user.role }}
            </span>
          </b-td>
          <b-td :class="{'py-3': isMobile}">
            <inertia-link
              :href="route('users.edit', user.id)"
              as="b-button"
              variant="outline-primary"
              size="sm"
            >
              <b-icon icon="pencil-fill" />
            </inertia-link>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'

export default {
  layout: Layout,
  components: {
    Header,
  },
  props: {
    users: Array,
  },
}
</script>
